var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-container"},[_vm._t("default"),_c('i',{staticClass:"iconfont",class:_vm.fontClass})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }